// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1gA-G","rootCenter":"LoadMoreObserver_rootCenter__QO-F7","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__bVMGm"};